import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from "@angular/core";
import { ShopWindowItem } from "../../model/shop-window-item";
@Component({
    selector: "pme-price-table",
    templateUrl: "./price-table.component.html",
    styleUrls: ["./price-table.component.scss"],
    standalone: false
})
export class PriceTableComponent implements OnInit, OnChanges{
  @Input() shopWindowItems: ShopWindowItem[] = [];
  @Output() buyClicked = new EventEmitter<void>();
  featureItems: any[] = [];
  constructor() {}

  swiperButtonNext: HTMLElement;
  swiperConfig: any;

  onBuyClicked(i): void {
    this.buyClicked.emit(i);
  }

  ngOnChanges(changes: SimpleChanges): void {
    
    let features = this.shopWindowItems.reduce((acc, item) => {
      item.featureList.forEach((feature) => {
        if (!acc[feature.name]) {
          acc[feature.name] = true;
        }
      });
      return acc;
    }, {});
    this.featureItems = Object.keys(features);
   
  }

  ngOnInit(): void {

  }
}
